<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
            <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
        </v-btn>
        <div v-if="loading">Loading...</div>
        <div v-else>
            <div v-html="html"></div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; 
export default {
    data() {
        return {
            loading: true,
            html: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            principle:null
        };
    },

    methods: {

       fetchBonafideData(ldid, prno) {
    this.loading = true;
    axios.post("/certificate/fetchBonafideData", { ldid: ldid, prno: prno, principle: this.principle })
    .then((res) => {
        if (res.data.flag === "YES") {
            let dynamicHtml = res.data.html;

            // if (res.data.signature_url && this.awspath) {
            //     const basePath = this.awspath.replace(/\/$/, "");
            //     const relativePath = res.data.signature_url.replace(/^\//, "");
            //     const fullImageUrl = `${basePath}/${relativePath}`;
                
            //     const signHtml = `<img src="${fullImageUrl}" style="height: 80px; display: block; margin: 0 auto -10px auto;" alt="Principal Sign" />`;
                
            //     dynamicHtml = dynamicHtml.replace("Principal", signHtml + "Principal");
            // }

            this.html = dynamicHtml;
        } else {
            this.showSnackbar("error", "Failed to fetch Bonafide");
        }
    })
    .catch(() => {
        this.showSnackbar("error", "Error in loading bonafide");
    })
    .finally(() => {
        this.loading = false;
    });
},

        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
            that.$store.state.drawer = true;
            };
            setTimeout(() => {
            window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        const ldid = this.$route.query.ldid;
        const prno = this.$route.query.prno;
        console.log("ldid============="+ldid);
        console.log("prno============="+prno);
        this.principle = localStorage.getItem("principle_id")
        this.awspath = localStorage.getItem("awspath");
        
        if (!prno) {
            alert("Invalid access");
            return;
        }

        this.fetchBonafideData(ldid, prno);
    }
};
</script>
<style>
.no-print:has(.v-breadcrumbs),
.breadcrumb-wrapper,
.v-breadcrumbs {
    display: none !important;
}

.v-content,
.v-container,
.v-content__wrap {
    padding-top: 0 !important;
    margin-top: 0 !important;
}

@media print {
    header,
    footer,
    nav,
    date,
    .no-print,
    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card,
    .v-snack {
        display: none !important;
    }

    html, body, #app, #inspire, .v-application--wrap, .v-content, .v-container, .v-col {
        padding: 0 !important;
        margin: 0 !important;
        background: transparent !important;
    }

    .printdiv,
    div {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    @page {
        size: A4 portrait;
        margin: 0 !important; 
    }
}
</style>